import React, { Component } from "react";

class error404 extends Component {
  render() {
    return (
      <>
        <div className="error-page-inner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="inner">
                  <h1 className="title theme-gradient">500!</h1>
                  <h3 className="sub-title">500 Error</h3>
                  <span>
                    An internal error occurred. Please try again later or
                    contact the support contact-cus@um6p.ma
                  </span>
                  <div className="error-button">
                    <a className="btn-default" href="/">
                      Back To Homepage
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default error404;
